if (!customElements.get('waitlist-element')) {
  customElements.define(
    'waitlist-element',
    class WaitlistElement extends HTMLElement {
      constructor() {
        super();
        this.title = '';
        this.options = '';
      }

      connectedCallback() {
        this.dialog = this.querySelector('[data-waitlist-dialog]');
        this.dialog?.addEventListener('click', this.handleDialogClick);
        this.dialog?.addEventListener('cancel', this.handleCancel);
        this.querySelectorAll('[data-waitlist-close]').forEach((el) =>
          el.addEventListener('click', this.hide.bind(this))
        );

        this.klaviyo = this.querySelector('[class^="klaviyo-form-"]');
        if (this.klaviyo) {
          this.klaviyoObserver = new MutationObserver(this.klaviyoLoaded.bind(this));
          this.klaviyoObserver.observe(this, { childList: true, subtree: true });
        }

        document.addEventListener('click', this.handleDocumentClick, true);
        document.addEventListener('join-waitlist', this.handleJoinEvent);
        document.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleDocumentClick, true);
        document.removeEventListener('join-waitlist', this.handleJoinEvent);
        document.removeEventListener('keydown', this.handleKeydown);
        this.klaviyoObserver?.disconnect();
      }

      handleDocumentClick = (event) => {
        const trigger = event.target.closest('[data-join-waitlist-button]');
        if (!trigger) return;
        event.preventDefault();
        const title = trigger.dataset.productTitle || this.resolveProductTitle(trigger);
        const variantTitle = trigger.dataset.variantTitle || this.resolveVariantTitle(trigger);
        this.openWith({ title, variant_title: variantTitle });
      };

      handleJoinEvent = (event) => {
        const detail = event.detail || {};
        this.openWith({
          title: detail.title || '',
          variant_title: detail.variant_title || detail.variant?.title || '',
        });
      };

      handleKeydown = (event) => {
        if (event.key === 'Escape' && this.hasAttribute('show')) this.hide();
      };

      handleDialogClick = (event) => {
        if (event.target === this.dialog) this.hide();
      };

      handleCancel = (event) => {
        event.preventDefault();
        this.hide();
      };

      resolveProductTitle(trigger) {
        const productInfo = trigger.closest('product-info, [data-product-id]');
        const heading = productInfo?.querySelector(
          '[data-product-title], .product-title, .product__title, h1'
        );
        return heading?.textContent?.trim() || document.title;
      }

      resolveVariantTitle(trigger) {
        const form = trigger.closest('form');
        const variantInput = form?.querySelector('input[name="id"]');
        if (!variantInput) return '';
        const opt = variantInput
          .closest('product-info, [data-product-id]')
          ?.querySelector('.variant-option__swatch-value');
        return opt?.textContent?.trim() || '';
      }

      klaviyoLoaded() {
        this.productTitleInput = this.querySelector('[id^="product_title_"]');
        this.productOptionsInput = this.querySelector('[id^="product_options_"]');

        this.updateInfo();

        if (this.productTitleInput) {
          const row = this.productTitleInput.closest('[data-testid="form-row"]');
          if (row) row.style.display = 'none';
        }
        if (this.productOptionsInput) {
          const row = this.productOptionsInput.closest('[data-testid="form-row"]');
          if (row) row.style.display = 'none';
        }
      }

      updateInfo() {
        if (this.productTitleInput) {
          this.productTitleInput.value = this.title;
          this.productTitleInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (this.productOptionsInput) {
          this.productOptionsInput.value = this.options;
          this.productOptionsInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      openWith({ title, variant_title }) {
        this.title = title || '';
        this.options = variant_title || '';
        this.updateInfo();
        this.show();
      }

      show() {
        this.setAttribute('show', '');
        document.documentElement.classList.add('waitlist-open');
        if (this.dialog && !this.dialog.open) {
          try {
            if (typeof this.dialog.showModal === 'function') {
              this.dialog.showModal();
            } else {
              this.dialog.setAttribute('open', '');
            }
          } catch (e) {
            this.dialog.setAttribute('open', '');
          }
        }
      }

      hide() {
        this.removeAttribute('show');
        document.documentElement.classList.remove('waitlist-open');
        if (this.dialog?.open) this.dialog.close();
      }
    }
  );
}
